import gql from 'graphql-tag';
import React from 'react';
import { Mutation } from 'react-apollo';

import { RequestLineFieldsFragment } from '../constants';
import { NAME as REQUEST_LINES_QUERY } from '../withCaseRequestLines';
import { CASE_REQUEST_ASSETS_QUERY_NAME } from '../../RequestAssetsForm/withRequestAssets/caseRequestAssetsQuery';

const refetchQueries = [REQUEST_LINES_QUERY, CASE_REQUEST_ASSETS_QUERY_NAME];

const resetAllAgreementsMutation = gql`
  mutation compositions_CaseRequestPanel_CaseResetAllAgreementLines(
    $caseId: ID!
  ) {
    resetAllAgreements(input: { caseId: $caseId }) {
      requestAgreementLines {
        agreed
        agreementLine {
          ...RequestLineFields
        }
      }
    }
  }
  ${RequestLineFieldsFragment}
`;

const resetAgreementMutation = gql`
  mutation compositions_CaseRequestPanel_CaseResetAgreementLine($id: ID!) {
    resetAgreement(input: { id: $id }) {
      requestAgreementLine {
        agreed
        agreementLine {
          ...RequestLineFields
        }
      }
    }
  }
  ${RequestLineFieldsFragment}
`;

const withCaseResetRequestAgreementLines = WrappedComponent => componentProps => (
  <Mutation mutation={resetAgreementMutation} refetchQueries={refetchQueries}>
    {dispatchResetAgreement => {
      const resetRequestAgreementLine = variables => {
        dispatchResetAgreement({
          variables,
        });
      };

      return (
        <Mutation
          mutation={resetAllAgreementsMutation}
          refetchQueries={refetchQueries}
        >
          {dispatchResetAllAgreements => {
            const resetAllRequestAgreementLines = variables => {
              dispatchResetAllAgreements({
                variables,
              });
            };

            return (
              <WrappedComponent
                {...componentProps}
                resetRequestAgreementLine={resetRequestAgreementLine}
                resetAllRequestAgreementLines={resetAllRequestAgreementLines}
              />
            );
          }}
        </Mutation>
      );
    }}
  </Mutation>
);

export default withCaseResetRequestAgreementLines;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withRequestAgreementLinesActions/withResetCaseAgreementLines.js